<div class="flex flex-col gap-3 min-w-[50rem] min-h-[25rem] align-items-center">
  <sigecom-input-search-new type="text" placeholder="Buscar..." (debouncedInput)="incTxResumoChange($event)" />

  <div class="p-2 overflow-y-scroll max-h-96 rounded-lg">
    <div class="flex flex-col gap-3">
      <div *ngIf="participants.totalElements! > 0; else empty"></div>
      <div *ngFor="let item of participants.content">
        <sigecom-list-item ngClass="flex" bgColor="bg-sigecom-item-selected">
          <div class="flex justify-between items-center">
            <div class="flex gap-3">
              <div class="flex gap-2">
                <div class="bg-[#012169] flex justify-center p-2 items-center w-6 h-6 rounded-full"
                  *ngIf="item.incBlCabecaChave">
                  <fa-icon class="text-[#E9CA26] text-xs" icon="key"></fa-icon>
                </div>
                <p class="font-bold">{{ item.ineObjInscricao.incTxResumo }}</p>
              </div>
              <sigecom-menu-bar-item (clickAction)="openModalViewParticipants(item.ineObjInscricao.incNrId)" icon="eye"
                color="sigecom-info" title="Ver mais informações do atleta" />
            </div>
            <sigecom-button *ngIf="!isAdded(item.ineNrId)" (buttonClicked)="addParticipant(item.ineNrId)" type="info"
              icon="plus" title="ADICIONAR" />
            <sigecom-button *ngIf="isAdded(item.ineNrId)" (buttonClicked)="removeParticipant(item.ineNrId)"
              class="rounded" type="gray" icon="xmark" title="ADICIONADO" />
          </div>
        </sigecom-list-item>
      </div>
    </div>
  </div>
</div>

<sigecom-pagination-list [totalPages]="participants.totalPages!" [maxDisplayedPages]="participants.totalPages!"
  (pageChange)="onPageChange($event)" />

<ng-template #empty>
  <p class="text-gray-700 p-1">Nenhum atleta encontrado</p>
</ng-template>